export function getQuery() {
  return location.search
    .slice(1)
    .split('&')
    .map(part => part.split('='))
    .filter(part => part)
    .reduce((obj, part) => {
      obj[part[0]] = decodeURIComponent(part[1])
      return obj
    }, {})
}

export function constructQuery(obj) {
  var query = Object.assign(getQuery(), obj)
  return '?' + Object.keys(query)
    .filter(key => key && query[key] || key && query[key] >= 0)
    .map(key => `${key}=${encodeURIComponent(query[key])}`)
    .join('&')
}

export function setQuery(obj) {
  location.search = constructQuery(obj)
}

export default function query(obj, opts = {}) {
  return obj
    ? opts.mock
      ? constructQuery(obj)
      : setQuery(obj)
    : getQuery()
}
